import Grid from '@mui/material/GridLegacy'
import { T } from 'shared/src/util/translation'
import { DataElement } from 'whats_inside/src/pages/deviceData/components/dataElement/DataElement'
import { NextExpectedMetering } from 'whats_inside/src/pages/deviceData/components/nextExpectedMetering/NextExpectedMetering'
import { RadialBar } from 'whats_inside/src/pages/deviceData/components/radialBar/RadialBar'

export const DeviceDataSkeleton = ({ useLabels }: { useLabels: boolean }) => {
  return (
    <>
      <section className='gauge-section'>
        <DataElement isLoading className='main' invert />
        <RadialBar isLoading percentage={0} />
      </section>
      <section className='device-data-section'>
        <DataElement isLoading regularContent={useLabels ? T('current_fill_level') : undefined} />
        <DataElement isLoading regularContent={useLabels ? T('freeUsableQuantity') : undefined} />
        <DataElement isLoading regularContent={useLabels ? T('product') : undefined} />
      </section>
      <section className='last-next-metering-section'>
        <Grid container>
          <Grid item xs={5}>
            <DataElement
              isLoading
              sameSizePartials
              regularContent={useLabels ? T('lastMeasurement') : undefined}
              align='right'
            />
          </Grid>
          <Grid item xs={5}>
            <NextExpectedMetering isLoading nextExpectedMeteringAt='' useLabels={useLabels} />
          </Grid>
        </Grid>
      </section>
    </>
  )
}
